import { useEffect } from 'react';

export type EventType = 'error' | 'info' | 'warning' | 'success';

interface Event {
  title: string;
  description?: string;
}

const emitEvent = (type: EventType, data: Event) => {
  const event = new CustomEvent(type, { detail: JSON.stringify(data) });
  document.body.dispatchEvent(event);
};

/**
 * The emitter, one function for the life of the app, so that a callback or
 * an effect that depends on it is not recreated on every render. A new
 * emitter per render recreated the feed list's loader on every render, and
 * its fetch effect then fetched again after every render (FEED-CORE 2.4).
 */
export const useEventEmit = () => emitEvent;

export const useEventListener = (
  type: EventType,
  onEvent: (data: Event) => void,
) => {
  useEffect(() => {
    const listener = (event: any) => {
      const data = JSON.parse(event.detail);
      onEvent(data);
    };

    document.body.addEventListener(type, listener);

    return () => {
      document.body.removeEventListener(type, listener);
    };
  }, []);
};
